// import { useState } from 'react'
// import { Input } from '../../Components/ui/input'
// import { Button } from '../../Components/ui/button'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../Components/ui/tabs'
import UserBasketHoldings from './UserBasketHoldings'
import UserBasketOrderHistory from './UserBasketOrderHistory'
import UserIndividualHoldings from './UserIndividualHoldings'
import UserSips from './UserSIPs'
import UserBasketSIPs from './UserBasketSIPs'
import UserNonFabitsAssets from './UserNonFabitsAssets'
import CreateMandate from './CreateMandate'

const UserHoldings = () => {
  const customerDetails = sessionStorage.getItem('actionPlanUser')
  const pan = JSON.parse(customerDetails)?.data?.panNumber
  const clientCode = JSON.parse(customerDetails)?.data?.uid?.split('-')[0]?.toUpperCase()

  // const [uccId, setUccId] = useState(pan)
  // const [submittedClientCode, setSubmittedClientCode] = useState(clientCode)

  // const handleSubmit = (e) => {
  //   e.preventDefault()
  //   if (uccId.trim()) {
  //     setSubmittedClientCode(uccId.trim().toUpperCase())
  //   }
  // }
  return (
    <div className='w-full h-screen p-2 md:p-4'>
      {/* <form
        onSubmit={handleSubmit}
        className='flex flex-col md:flex-row gap-3 md:gap-x-7 items-stretch md:items-center mb-4 md:mb-6'
      >
        <div className='flex-[2]'>
          <Input
            placeholder='Enter Client Code'
            id='uccId'
            name='uccId'
            value={uccId}
            onChange={(e) => {
              setUccId(e.target.value)
              setSubmittedClientCode('')
            }}
            className='text-sm md:text-base'
          />
        </div>

        <Button
          type='submit'
          className='w-full text-base md:text-lg max-w-full md:max-w-[200px] py-2 md:py-3'
        >
          SUBMIT
        </Button>
      </form> */}

      {clientCode ? (
        <div>
          <h2 className='text-lg md:text-xl font-semibold mb-3 md:mb-4'>
            Holdings for Client Code: {clientCode}
          </h2>
          {/* Tab UI can go here */}
          <div className='w-full max-w-[1128px] pt-6 md:pt-12 mx-auto'>
            <Tabs defaultValue='userBasketHoldings' className='relative mr-auto w-full'>
              <TabsList className='fabits-holdings-tabs mb-4 flex h-auto w-full justify-start gap-1 overflow-x-auto rounded-[999px] border-0 bg-[var(--fb-surface-muted)] p-1 shadow-none'>
                {[
                  ['userBasketHoldings', 'Basket Holdings'],
                  ['userIndividualHoldings', 'Individual Holdings'],
                  ['Non Fabits Assets', 'Non Fabits Assets'],
                  ['UserSIPs', 'SIPs'],
                  ['BasketSIPs', 'Basket SIPs'],
                  ['userBasketOrderHistory', 'Order History'],
                  ['CreateMandate', 'Create Mandate'],
                ].map(([value, label]) => (
                  <TabsTrigger
                    key={value}
                    value={value}
                    className='fabits-pill-trigger h-9 shrink-0 flex-none basis-auto rounded-full border-0 px-3 text-xs font-semibold text-[var(--fb-text-muted)] shadow-none md:h-10 md:px-4 md:text-sm data-[state=active]:bg-[var(--fb-accent)] data-[state=active]:text-white data-[state=active]:shadow-[var(--fb-shadow-blue)]'
                  >
                    {label}
                  </TabsTrigger>
                ))}
              </TabsList>

              <TabsContent value='userBasketHoldings'>
                <UserBasketHoldings clientCode={clientCode} panNumber={pan} />
              </TabsContent>

              <TabsContent value='userIndividualHoldings'>
                <UserIndividualHoldings clientCode={pan} />
              </TabsContent>

              <TabsContent value='Non Fabits Assets'>
                <UserNonFabitsAssets clientCode={pan} />
              </TabsContent>

              <TabsContent value='UserSIPs'>
                <UserSips clientCode={clientCode} />
              </TabsContent>

              <TabsContent value='BasketSIPs'>
                <UserBasketSIPs clientCode={clientCode} />
              </TabsContent>

              <TabsContent value='userBasketOrderHistory'>
                <UserBasketOrderHistory clientCode={clientCode} />
              </TabsContent>

              <TabsContent value='CreateMandate'>
                <CreateMandate clientCode={clientCode} />
              </TabsContent>
            </Tabs>
          </div>
        </div>
      ) : (
        <p className='text-gray-600 text-sm md:text-base'>Enter Client code above to start</p>
      )}
    </div>
  )
}

export default UserHoldings
